/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicRecommendationV2Processor extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicRecommendationV2Processor");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicRecommendationV2Processor.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicRecommendationV2Processor>): BackgroundJobPayloadForPeriodicRecommendationV2Processor {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicRecommendationV2Processor(), model);
        BackgroundJobPayloadForPeriodicRecommendationV2Processor.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicRecommendationV2Processor>): BackgroundJobPayloadForPeriodicRecommendationV2Processor {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicRecommendationV2Processor.newInstance(<BackgroundJobPayloadForPeriodicRecommendationV2Processor> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicRecommendationV2Processor) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicRecommendationV2Processor.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicRecommendationV2Processor): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicRecommendationV2Processor.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
